import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Translate from '../../i18n/Translate';

import { AuthContext } from '../../contexts/AuthProvider';

import {
  PlaneIcon,
  BoatIcon,
  LocationIcon,
  PaymentIcon,
  DisneyIcon,
  NacionalIcon,
  FlyersIcon,
  StarIcon,
  ArrowDownIcon,
} from '../../components/icons';
import PrivateLink from '../../components/PrivateLink';

const SubHeader = () => {
  const { user } = useContext(AuthContext);
  const { t } = useTranslation();

  const aereosUrl = process.env.REACT_APP_AEREOS_URL;
  const aereosPass = process.env.REACT_APP_AEREOS_PASS;
  const disneyUrl = process.env.REACT_APP_DISNEY_URL;
  const nacionalUrl = process.env.REACT_APP_NACIONAL_URL;
  const reservasUrl = process.env.REACT_APP_RESERVAS_URL_NEMO;

  return (
    <nav className='subheader'>
      <div className='subheader__container'>
        {/* Aereos */}
        <PrivateLink
          href={`${aereosUrl}`}
          className='subheader__container-link'
          isAuthenticated={user.isAuthenticated}
        >
          <PlaneIcon />
          <Translate langkey='links.option1' />
        </PrivateLink>

        {/* Cruceros */}
        <NavLink to={`${t('routes.cruise')}`} className='subheader__container-link'>
          <BoatIcon />
          <Translate langkey='links.option2' />
        </NavLink>

        {/* Disney */}
        {/*<PrivateLink
          href={`${disneyUrl}975`}
          className='subheader__container-link'
          isAuthenticated={user.isAuthenticated}
        >
          <DisneyIcon />
          <Translate langkey='links.option5.title' />
        </PrivateLink>*/}

        {/* Nacionales */}
        {/*<PrivateLink
          href={`${nacionalUrl}${user.credentials}`}
          className='subheader__container-link'
          isAuthenticated={user.isAuthenticated}
        >
          <NacionalIcon />
          <Translate langkey='links.option10' />
        </PrivateLink>*/}

        {/* Circuitos */}
        <NavLink to={`${t('routes.circuits')}`} className='subheader__container-link'>
          <LocationIcon />
          <Translate langkey='links.option3' />
        </NavLink>

        {/* Collections */}
        <div className='subheader__container__dropdowns'>
          <button>
            <StarIcon />
            <Translate langkey='links.option7.title' />
            <ArrowDownIcon className='arrowDownIcon' />
          </button>

          <div className='subheader__container__dropdowns__content'>
            <span className='triangle' />
            <NavLink to={`${t('routes.weddings')}`}>
              <Translate langkey='links.option7.link2' />
            </NavLink>
            {/*<a href={`${t('routes.fifteenyears')}`} rel='noreferrer' target='_blank'>
              <Translate langkey='links.option7.link5' />
            </a>*/}
          </div>
        </div>

        {/* Flyers */}
        <NavLink to={`${t('routes.flyers')}`} className='subheader__container-link'>
          <FlyersIcon />
          <Translate langkey='links.option6' />
        </NavLink>

        {/* Formas de pago */}
        <div className='subheader__container__dropdowns'>
          <button>
            <PaymentIcon />
            <Translate langkey='links.option4.title' />
            <ArrowDownIcon className='arrowDownIcon' />
          </button>

          <div className='subheader__container__dropdowns__content'>
            <span className='triangle' />

            <NavLink
              to={`${t('routes.airlinecompanies')}`}
              className='subheader__container-link'
            >
              <Translate langkey='links.option4.link1' />
            </NavLink>

            <NavLink
              to={`${t('routes.towertravel')}`}
              className='subheader__container-link'
            >
              <Translate langkey='links.option4.link2' />
            </NavLink>

            <a
              href={`${t('routes.paymentmethods')}`}
              className='subheader__container-link'
              target='_blank'
              rel='noreferrer'
            >
              <Translate langkey='links.option4.link3' />
            </a>
          </div>
        </div>
        {/* Reservas online */}
        <PrivateLink
          href={`${reservasUrl}`}
          className='callToAction'
          isAuthenticated={user.isAuthenticated}
        >
          <Translate langkey='links.reservas_online' />
        </PrivateLink>
      </div>
    </nav>
  );
};

export default SubHeader;
